module.exports = "/_next/static/images/decred-1789a398758f3a833f28fbd222182fc4.png";